//
//
//
//
//
//
//
//
//

export default {
  props: {
      message: {
      type: Object,
      required: true
    }
  }
}
